import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=fab7bd48&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab7bd48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab7bd48')) {
      api.createRecord('fab7bd48', component.options)
    } else {
      api.reload('fab7bd48', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=fab7bd48&scoped=true&", function () {
      api.rerender('fab7bd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23hFhlu25PbqV/JS/comp/Voucher-Unit.vue"
export default component.exports